import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Buenos Aires`,
  location: {
    lat: -34.603722,
    lng: -58.381592,
  },
  drivers: {
    label: [`Mateo`, `Gianfranco`, `Marcelo`],
    start_address: [
      `Lavalle 1718, C1019 CABA, Buenos Aires, Argentina`,
      `Lavalle 1718, C1019 CABA, Buenos Aires, Argentina`,
      `Lavalle 1718, C1019 CABA, Buenos Aires, Argentina`,
    ],
    end_address: [
      `Lavalle 1718, C1019 CABA, Buenos Aires, Argentina`,
      `Laprida 1621, C1425 EKM, Buenos Aires, Argentina`,
      `Lavalle 1718, C1019 CABA, Buenos Aires, Argentina`,
    ],
  },
};

const stops: IExampleLocation = {
  name: `Buenos Aires`,
  location: {
    lat: -34.603722,
    lng: -58.381592,
  },
  stops: {
    label: [
      `Chila`,
      `Iñaki Restaurante`,
      `La Cocina`,
      `Oviedo Restaurante`,
      `Gran Paraiso`,
      `Restaurante Chiquilín`,
      `Aramburu`,
      `Centro Vasco Francés Restaurante`,
      `El Burladero`,
      `Le Famiglie`,
    ],
    address: [
      `Av. Alicia Moreau de Justo 1160, C1107AAT Puerto Madero, Buenos Aires, Argentina`,
      `Moreno 1341, C1091 ABA, Buenos Aires, Argentina`,
      `Av. Pueyrredón 1508, C1118 AAS, Buenos Aires, Argentina`,
      `Beruti 2602, C1425 BBD, Buenos Aires, Argentina`,
      `Gral. José Garibaldi 1428, Buenos Aires, Argentina`,
      `Montevideo 321 1042, C1019 ABG, Buenos Aires, Argentina`,
      `Pasaje del Correo, Vicente López 1661, C1103 ACY, Buenos Aires, Argentina`,
      `Moreno 1370, C1091 ABB, Buenos Aires, Argentina`,
      `Pres. José Evaristo Uriburu 1488, C1425 AAN, Buenos Aires, Argentina`,
      `Salta 440, C1074 AAJ, Buenos Aires, Argentina`,
    ],
    address_details: [``, ``, `Piso 1 Puerta 3`, ``, `4º 5ª`, ``, `2ºB`, ``, ``, `4F`],
    delivery_label: [
      `Alessia Giménez`,
      `Catalina Ruiz`,
      `Juan Peralbo`,
      `Thiago Acosta`,
      `Juan Rodriguez`,
      `Paula Castro`,
      `Lourdes Lobo`,
      `Mateo Tinelli`,
      `Joaquín Gutiérrez`,
      `Santino Macri`,
    ],
    delivery_address: [
      `José Hernández 2431, C1426 EOQ, Buenos Aires, Argentina`,
      `Gral. Lucio Norberto Mansilla 3267, Buenos Aires, Argentina`,
      `Av. Entre Ríos 633, C1080 CABA, Argentina`,
      `Honduras 3750, C1180 ACB, Buenos Aires, Argentina`,
      `Ayacucho 1981, C1112 AAI, Buenos Aires, Argentina`,
      `San José de Calasanz 176, C1424 AHD, Buenos Aires, Argentina`,
      `Honduras 5246, C1414 BMV, Buenos Aires, Argentina`,
      `Peña 2382, C1125 ACB, Buenos Aires, Argentina`,
      `Amenábar 1975, C1428 CQC, Buenos Aires, Argentina`,
      `Irigoyen 864, C1407 CAT, Buenos Aires, Argentina`,
    ],
    delivery_address_details: [``, `Piso 3 Puerta 2`, ``, `Local 4`, ``, ``, `Planta 2`, ``, `Oficina 8`, ``],
  },
};

export { drivers, stops };
